import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store/store'
import vuetify from './plugins/vuetify'
import VueSweetalert2 from 'vue-sweetalert2'
import 'vue-material-design-icons/styles.css'
import Toolbar from './components/core/Toolbar.vue'
import Navigation from './components/core/NavigationDrawer.vue'
import Breadcrumbs from './components/core/Breadcrumbs.vue'
import axios from 'axios'
import Cookies from 'vue-cookies'
import VueFusionCharts from 'vue-fusioncharts'
import FusionCharts from 'fusioncharts'
import Column2D from 'fusioncharts/fusioncharts.charts'
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion'

// register VueFusionCharts component

Vue.use(VueSweetalert2)
Vue.use(Cookies)
Vue.use(VueFusionCharts, FusionCharts, Column2D, FusionTheme)
Vue.component('toolbar', Toolbar)
Vue.component('navigation', Navigation)
Vue.component('breadcrumbs', Breadcrumbs)

Vue.config.productionTip = false
axios.defaults.baseURL = 'https://padron-bend.deersystems.mx/'
// axios.defaults.baseURL = 'http://distrito.padron/'
// axios.defaults.baseURL = 'http://pad-bend/'

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
